import { connect } from "react-redux";
import {
  getCampaignById,
  getEmailChannelAggregated,
  getEmailChannelStatsAggregated,
  setReportDateRange,
  setChannelCampaignId,
  getCampaignTopLinkStats,
  setSegmentId,
} from "../../actions/Campaign";
import { selectClient } from "../../actions/App";

import TopLinksClick from "../../components/Campaigns/Report/TopLinksClick";

const mapStateToProps = state => {
  const { clients } = state.app;
  const {
    emailAggregatedReport,
    emailAggregatedStats,
    reportDateRange,
    campaignDetail,
    topLinkStats,
    channelCampaignId,
    loadingTopLinkStats,
  } = state.campaigns;
  return {
    emailAggregatedReport,
    emailAggregatedStats,
    campaignDetail,
    channelCampaignId,
    topLinkStats,
    loadingTopLinkStats,
    reportDateRange: reportDateRange ? reportDateRange : "life-of-campaign",
    client_id: state.app.client_info && state.app.client_info.id,
    client_tz: state.app.client_info && state.app.client_info.timezone,
    client_info: state.app.client_info,
    clients,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCampaignById(id) {
      dispatch(getCampaignById(id, false));
    },
    selectClient(cid) {
      dispatch(selectClient(cid));
    },
    getEmailChannelAggregatedReport(groupCampaignId, campaignId, dateRange) {
      dispatch(
        getEmailChannelAggregated(groupCampaignId, campaignId, dateRange),
      );
    },
    getEmailChannelStatsAggregated(groupCampaignId, campaignId, dateRange) {
      dispatch(
        getEmailChannelStatsAggregated(
          groupCampaignId,
          campaignId,
          dateRange === "aggregated" ? "aggregate" : dateRange,
        ),
      );
    },
    getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit) {
      dispatch(
        getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit),
      );
    },
    setReportDateRange(dateRange) {
      dispatch(setReportDateRange(dateRange.value));
    },
    setSegmentId(data) {
      dispatch(setSegmentId(data.value));
    },
    setChannelCampaignId(data) {
      dispatch(setChannelCampaignId(data.value));
    },
  };
};

const TopLinksClicksContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopLinksClick);

export default TopLinksClicksContainer;



// WEBPACK FOOTER //
// ./src/containers/Campaigns/TopLinksClicks.js